import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT_APP } from 'store/sagas'

export const NAMESPACE = 'KanBo/MyBoard/view/'
export const INIT = NAMESPACE + 'INIT'
export const SET_PERMISSION_LEVEL = NAMESPACE + 'SET_PERMISSION_LEVEL'
export const SET_ID = NAMESPACE + 'SET_ID'
export const SET_USER_ID = NAMESPACE + 'SET_USER_ID'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD_LIST = NAMESPACE + 'ADD_LIST'
export const REMOVE_LIST = NAMESPACE + 'REMOVE_LIST'
export const SET_LISTS = NAMESPACE + 'SET_LISTS'
export const SET_LISTS_SCROLL_LEFT = NAMESPACE + 'SET_LISTS_SCROLL_LEFT'

const initialState = {
  id: 0,
  userId: 0,
  name: '',
  lists: [],
  isLoading: false,
  isLoaded: false,
  permissionLevel: 0,
  listsScrollLeft: 0
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
    case INIT:
      return {
        ...initialState,
        ...action.payload,
        ...((action.payload && action.payload.changed) ? {} : {
          listsScrollLeft: state.listsScrollLeft
        })
      }
    case SET_PERMISSION_LEVEL:
      return {
        ...state,
        permissionLevel: action.payload.permissionLevel
      }
    case SET_ID:
      return {
        ...state,
        id: action.payload.id
      }
    case SET_USER_ID:
      return {
        ...state,
        userId: action.payload.userId
      }
    case SET_NAME:
      return {
        ...state,
        name: action.payload.name
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD_LIST:
      return {
        ...state,
        lists: addUniqueValueToArray({
          array: state.lists,
          value: action.payload.id,
          index: action.payload.index
        })
      }
    case REMOVE_LIST:
      return {
        ...state,
        lists: state.lists.filter(id => id !== action.payload.id)
      }
    case SET_LISTS:
      return {
        ...state,
        lists: action.payload.lists
      }
    case SET_LISTS_SCROLL_LEFT:
      return {
        ...state,
        listsScrollLeft: action.payload.listsScrollLeft
      }
    default: return state
  }
}

export function init (payload) {
  return {
    type: INIT,
    payload
  }
}

export function setPermissionLevel ({ permissionLevel }) {
  return {
    type: SET_PERMISSION_LEVEL,
    payload: {
      permissionLevel
    }
  }
}

export function setId ({ id }) {
  return {
    type: SET_ID,
    payload: {
      id
    }
  }
}

export function setUserId (userId) {
  return {
    type: SET_USER_ID,
    payload: {
      userId
    }
  }
}

export function setName ({ name }) {
  return {
    type: SET_NAME,
    payload: {
      name
    }
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function addList ({ id, index }) {
  return {
    type: ADD_LIST,
    payload: {
      id,
      index
    }
  }
}

export function removeList ({ id }) {
  return {
    type: REMOVE_LIST,
    payload: {
      id
    }
  }
}

export function setLists ({ lists }) {
  return {
    type: SET_LISTS,
    payload: {
      lists
    }
  }
}

export function setListsScrollLeft (listsScrollLeft) {
  return {
    type: SET_LISTS_SCROLL_LEFT,
    payload: {
      listsScrollLeft
    }
  }
}